<template>
  <div class="details"
       id="apply">
    <div class="details_wrap"
         ref="details_wrap">

      <div>
        <i-player
                v-if="Object.keys(videoData).length"
                :videoinfo="videoData"
                :isCanPlay="isCanPlay"
                  @watchPay="watchPay">

        </i-player>
      </div>
      <div class="menus">

        <div class="videotitle"
             v-if="this.$route.query.type=='video'">
          <div class="title">
            <div class="name">{{videoData.vTitle?videoData.vTitle:''}}</div>
            <button v-if="this.$route.query.type=='live'&&videoData.lState==0"
                    class="footer_yybm"
                    @click="signUp(sing)"
                    :style="{background:sing==1?'#999999':'linear-gradient(0deg,rgba(9,131,255,1) 0%,rgba(33,175,255,1) 100%)'}">{{text}}</button>
          </div>
          <div class="videodesc">

            <p v-if="videoData.vCreateDt">{{getTimes(videoData.vCreateDt)}}</p>
            <span class="img_text"
                  v-if="this.$route.query.type=='video'">
              <img src="../../assets/images/sc.png"
                   alt
                   v-if="videoData.vIsCollect==1"
                   @click="videoCollect(1)" />
              <img src="../../assets/images/unsc.png"
                   v-if="videoData.vIsCollect==0"
                   @click="videoCollect(0)"
                   alt />
              <span>{{texts}}</span>
            </span>
          </div>
        </div>
        <ul class="tabmenus">
          <!--三个和两个样式-->
          <!--:style="{width:teacher==1?'50%':'2.46rem'}"-->
          <li v-for="(item,index) in list"
              @click="getTab(item,index)"
              :class="{'active':active==index,}"
              style="width: 50%;"
              :key="index">
            <span :style="{borderRight:teacher==1?'none':'',width:'100%',textAlign:'center'}">{{item.name}}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 视频讲师介绍 -->
    <div v-if="activeTab=='v1'"
         class="box">
      <i-lecturer :value="videoData.teacher"></i-lecturer>
    </div>
    <div class="box"
         v-if="activeTab=='v2'">
      <!--课程介绍-->
      <i-course v-if="videoData.vDesc!=undefined&&(videoData.vDesc!=null&&videoData.vDesc!='')"
                :value="videoData.vDesc"></i-course>
    </div>
    <div v-if="activeTab=='v3'"
         class="container box">
      <i-video :video_newest="video_newest"
               v-on:listtomember="fatertpl"
               v-if="video_newest.length>0"></i-video>
      <img src="../../assets/images/nothing.png"
           alt
           v-else
           class="nothing" />

      <!--相关视频-->
    </div>

    <div v-if="activeTab=='v4'"
         class="box">
      <div v-if="!isCharge"
           style="width: 100%">
        <photo v-if="pptlist.length>0"
               :imgs="pptlist"></photo>
        <img src="../../assets/images/nothing.png"
             alt
             v-else
             class="nothing" />
      </div>

      <div class="limits"
           v-if="isCharge">
        <img src="../../assets/images/chahua.png"
             alt />
        <div class="a">
          <span>您尚未购买课程，购买课程后才能观看</span>
        </div>

      </div>
    </div>
    <!-- 没有权限 -->

    <div v-if="showimg"
         class="showimg"
         @click="cancelshowimg">
      <img :src="imgurl"
           alt />
    </div>

    <div>
      <div class="buyCC"
          v-if="isCharge"
          @click="subscribe">
        <span>购买课程</span>
        <span>¥{{curPrice}}</span>
      </div>
    </div>
    
  </div>
</template>
<script>
import iLecturer from "../container/lecturer";
import iCourse from "../container/course";
import iChat from "../iChat/iChat";
import iPlayer from "../container/player";
import iVideo from "../container/videoList";
import weui from "weui.js";
import bus from "../bus/index";
import photo from "./photo";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';


export default {
  data () {
    return {

      curPrice: "",
      isshowtime: true,
      pptlist: [],
      isCanPlay: null,// 是否在可播放的时间段内

      active: this.$route.query.type == "live" ? 0 : 0,
      activeTab: "v2",
      videoData: null,
      sing: 0,
      text: "预约报名",
      texts: "收藏",
      anlist: [],
      boxheight: "",
      teacher: this.$route.query.type == "live" ? "1" : "0",
      list: [
        // { name: "讲师介绍", id: "v1" },
        { name: "课程介绍", id: "v2" },
        { name: "相关课程", id: "v3" },
        // { name: "PPT", id: "v4" }
      ],
      video_newest: [],
      ra_wxUser: null,
      isQuestion: false,
      workVisb: false,
      issuccessinfo: true,
      answer: [],
      rightanswer: [],
      socket: "",
      name: "",
      org: "",
      hasNameOrg: "",
      imgurl: "",
      showimg: false,
      num: "0",
      //vIsCharge: '0', // 是否收费
      isBuyed: false // 用户是否已经购买



    };
  },
  props: {},
  components: {
    iLecturer,
    iCourse,
    iChat,
    iPlayer,
    iVideo,
    photo

  },

  computed: {
    isCharge () {
      let status = false;
      //是否已购买
      if (!this.videoData.buyed) {
        status = true
      }

      return status
    }

  },
  created () {
    this.$waiting.show(3);
  },
  async mounted () {
    this.ra_wxUser= await loginService.getLoginUser();

    this.$route.query.type = this.$route.query.type
      ? this.$route.query.type
      : "live";
    this.$route.query.LiveId = this.$route.query.LiveId
      ? this.$route.query.LiveId
      : 12;
    this.$wxFn.wxConfig();
    //存储直播来源参数
    localStorage.setItem("source", this.$route.query.source);
    localStorage.setItem("share", "");
    this.getvideodetails();
    //这里需要校验路由中的渠道参数：判断是否有该参数，并根据不同的参数保存该用户的来源
    //需要的参数1、渠道参数；2、微信用户信息  3、
  },
  methods: {
    // 点击视频播放
    watchPay () {
      this.subscribe()

    },

    onlinecount (data) {
      this.num = data;
    },
    onlineuser (data) {
      this.num = data;
    },

    fatertpl (data) {
        
    },


    cancelshowimg () {
      this.showimg = false;
      this.issuccessinfo = false;
    },
    updateuser () {
      if (this.name == "" || this.org == "") {
        this.topTips("请输入姓名和单位！");
        return false;
      }
      let params = {
        id: this.ra_wxUser.uId,
        name: this.name,
        org: this.org
      };
      this.$postHttp(AppSetting.baseUrl + "/student/update", params).then(res => {
        if (res.data.code == 0) {
          this.hasNameOrg = 1;
          this.$postHttp(AppSetting.baseUrl + "/common/credential", {
            sid: this.ra_wxUser.uId,
            vid: this.$route.query.videoId
          }).then(res => {
            if (res.data.code == 0) {
              this.issuccessinfo = false;
              this.reginfo = false;
              this.showimg = true;
              this.$set(this.videoData, "vIsCredential", 1);
              this.imgurl = res.data.credential.creImgUrl;
            }
          });
        }
      });
    },

    changeInput (value, index) {
      // console.log(value);
      this.answer[index] = value;
    },

    async videoCollect (type) {
      this.ra_wxUser =await loginService.getLoginUser();
      if (await loginService.isNotLogin()) {
        this.login();
      } else if (this.ra_wxUser.uId) {
        if (type == 0) {
          this.$postHttp(AppSetting.baseUrl + "/video/collection", {
            uid: this.ra_wxUser.uId,
            vid: this.$route.query.videoId
          }).then(res => {
            bus.$emit("isstop", "stop");
            if (res.data.code == 0) {
              this.texts = "已收藏";
              this.videoData.vIsCollect = 1;
              this.toast("收藏成功");
            } else {
              this.topTips("收藏失败");
            }
          });
        } else {
          bus.$emit("isstop", "stop");
          weui.dialog({
            content: "确定要取消收藏吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: res => { }
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/video/collection/cancel", {
                    uid: this.ra_wxUser.uId,
                    vid: this.$route.query.videoId
                  }).then(res => {
                    if (res.data.code == 0) {
                      this.texts = "收藏";
                      this.videoData.vIsCollect = 0;
                      this.toast("取消收藏成功");
                    } else {
                      this.topTips("取消收藏失败");
                    }
                  });
                }
              }
            ]
          });
        }
      }
    },
    login () {
      loginService.login(this.$router)
      .then(loginUser=>{
        this.ra_wxUser=loginUser
      })
    },

    async signUp (status) {
      this.ra_wxUser =await loginService.getLoginUser();
      if (await loginService.isNotLogin()) {
        this.login();
      } else if (this.ra_wxUser.uPhone || this.ra_wxUser.uOrg) {
        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + "/live/appointment", {
            uid: this.ra_wxUser.uId,
            lid: this.$route.query.liveId
          }).then(res => {
            if (res.data.code == 0) {
              this.$set(this.videoData, "lAppointNum", res.data.num);
              this.text = "已预约";
              this.sing = 1;
              this.$toast.success("预约成功");
            } else {
              this.topTips("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: res => {
                  // alert('取消')
                }
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser.uId,
                    lid: this.$route.query.liveId
                  }).then(res => {
                    if (res.data.code == 0) {
                      this.$set(this.videoData, "lAppointNum", res.data.num);
                      this.text = "预约报名";
                      this.sing = 0;
                      this.$toast.success("取消成功");
                    } else {
                      this.topTips("取消预约失败");
                    }
                  });
                }
              }
            ]
          });
        }
      }
    },
    getTimes (value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy.MM.dd hh:mm");
    },
    getTab (item, index) {
      this.activeTab = item.id;
      console.log("---------------------------------------"+this.activeTab)
      this.active = index;
      this.issuccessinfo = true;
      if (index == 1 && !this.video_newest.length) {
        this.$postHttp(AppSetting.baseUrl + "/video/list/condition", {
          type: this.videoData.vEgid
        }).then(res => {
          if (res.data.code == 0) {
            let videoId = this.$route.query.videoId;
            this.video_newest = res.data.list.filter(v => v.vId != videoId);
          }
        });
      }
    },

    getvideodetails () {
      this.$postHttp(AppSetting.baseUrl + "/video/detail", {
        vid: this.$route.query.videoId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0"
      }).then(res => {
        if (res.data.code == 0) {
            this.videoData = res.data.video;
            this.isCanPlay = res.data.isCanPlay;
            this.videoData.showWatermark = res.data.showWatermark; // 是否展示水印功能
            this.curPrice = res.data.video.vFees;

          //是否会员观看标志
          this.isVipBuy = res.data.isfree;
          console.log(this.isVipBuy)
          // v_is_public
          if(this.videoData.vIsCharge == 0){//免费
                  this.curPrice = "0";
                  this.videoData.vFees = "0";
          }else if(this.isVipBuy == "1"){//会员免费
                  this.curPrice = "0";
                  this.videoData.vFees = "0";
          }



          //this.vIsCharge = this.videoData.vIsCharge
          this.isBuyed = res.data.video.buyed;
          console.log(this.isBuyed)
          this.hasNameOrg = res.data.hasNameOrg;


          this.$waiting.hide();
          this.texts = this.videoData.vIsCollect == 1 ? "已收藏" : "收藏";
          let share_title =
            this.videoData.vTitle !== null ? this.videoData.vTitle : "";

          // //微信不支持
          let share_img =
            this.videoData.vShareUrl != null ? this.videoData.vShareUrl : "";

          let desc = this.videoData.vDesc != null ? this.videoData.vDesc : "";
          let sharedesc =
            "" +
            this.videoData.teacher.uName +
            "" +
            this.videoData.teacher.uOrg; //分享描述

          let re = new RegExp("<[^<>]+>", "g");
          let text = desc.replace(re, "");
          //或
          let share_desc = desc.replace(/<[^<>]+>/g, "");
          setTimeout(() => {
            document.title = this.videoData.vTitle;
          }, 100);

          // let share_url = '';
          let hostname = location.hostname;

          let share_url = window.location.href;
          let firends =
            this.videoData.teacher.uOrg +
            this.videoData.teacher.uName +
            "：" +
            this.videoData.vTitle;
          // console.log('分享----》',share_title, sharedesc, share_img, share_url,this.$route.query.videoId)
          this.$wxFn.share(
            share_title,
            sharedesc,
            share_img,
            share_url,
            this.$route.query.videoId,
            firends,
            "video"
          );



        }
      });



      this.$postHttp(AppSetting.baseUrl + "/video/ppt", {
        vid: this.$route.query.videoId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0"
      }).then(res => {
        if (res.data.code == 0) {
          this.pptlist = res.data.list || [];
        }
      });
    },
    onBridgeReady (params) {

      var that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp + '', //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: params.nonceStr, //支付签名随机串，不长于 32 位
          package: params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: params.sign //支付签名
        },
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            that.buyed = true
            that.videoData.buyed = true
            //that.$router.push({ path: "/myOrder" });
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            // this.alert("支付失败！");
          }
        }
      );
    },
    subscribe () {
      // this.videoData.buyed = true
      // return
      if (!this.ra_wxUser) {
        this.login();
        return
      }
      let param = {
        orderType: 1, //0 vip购买，1 视频购买，2直播购买，3会议购买
        bId: this.$route.query.videoId,
        payPrice: this.curPrice,
        uid: this.ra_wxUser.uId,
        isVipBuy:this.isVipBuy,
      };
      this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then(res => {
        if (res.data.code == 0) {
          if (this.curPrice <= 0) {

            this.buyed = true
            this.videoData.buyed = true
            this.$toast.success('购买成功')
            return
          }
          const pay_params = JSON.parse(res.data.parMap);
          if (typeof WeixinJSBridge === "undefined") {
            console.log('走这里1')
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            console.log('走这里2')
            this.onBridgeReady(pay_params);
          }
        } else if (res.data.code == 2) {
          this.toast("购买成功");
        } else {
          this.confirm(
            "授权失败，点击确定微信授权",
            "取消",
            "确定",
            () => {
              return true;
            },
            () => {
              this.login();
              return true;
            }
          );
        }
      });
    },
  },




};
</script>
<style scoped lang="scss">
.msgcontent {
  font-size: 0.24rem;
}
.megp {
  display: flex;
  position: absolute;
  bottom: 0.5rem;
  button {
    align-items: center;
    border: none;
    outline: none;
    color: #ffffff;
    width: 2rem;
    height: 0.8rem;
    text-align: center;
    border-radius: 5px;
  }
  button:nth-of-type(2) {
    margin-left: 10px;
    background: rgb(9, 131, 255);
  }
}
.ichatbox {
  background: #ffffff;
  padding-top: 0.2rem;
  flex-grow: 1;
  overflow: hidden;
  img {
    display: inline-block;
    width: 1rem;
    height: 1rem;
  }
}
.details {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  flex-direction: column;
  .details_wrap {
    /*height: 6.42rem;*/
    flex-grow: 0;
    z-index: 1;
  }
}
.glssktime {
  background: #f4f5f4;
  height: 1.1rem;
  width: 100%;
  padding: 0.1rem 0 0.2rem;
  box-sizing: border-box;
  > div {
    height: 0.8rem;
    font-size: 0.32rem;
    color: #333;
    line-height: 0.8rem;
    padding-left: 0.29rem;
    box-sizing: border-box;
    > span {
      font-size: 0.24rem;
      span {
        display: inline-block;
        font-size: 0.38rem;
        color: #1699ff;
        margin-right: 0.07rem;
      }
    }
  }
}

.bgoptons {
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0px;
  bottom: 0px;
  z-index: 1000 !important;
  div {
    width: 6rem;
    max-height: 8rem;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    margin-top: 2.54rem;
    margin-left: 0.75rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 3000 !important;
    position: relative;
    padding-bottom: 0.3rem;
    > ul {
      /*height: 3.7rem;*/
      /*width: 5rem;*/
      width: 100%;
      overflow-y: scroll;
      padding: 0.22rem 0.3rem 0px;
      box-sizing: border-box;
    }
  }
  .outline {
    padding: 0.1rem;
    display: flex;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #0e94ff;
    width: 0.32rem;
    height: 0.32rem;
    position: relative;
    margin-right: 0.1rem;
  }

  i {
    position: absolute;
    left: 0.06rem;
    top: 0.06rem;
    border-radius: 50%;
    display: inline-block;
    width: 0.17rem;
    height: 0.17rem;
    /*border: 1px solid #949393;*/
    vertical-align: middle;
    margin-right: 0.1rem;
  }
  .active {
    background: #0e94ff;
    /*padding: 0.1rem;*/
    /*box-sizing: border-box;*/
    display: inline-block;
  }
  &.active {
    i {
      &:after {
        content: "·";
        position: absolute;
        width: 60%;
        height: 60%;
        background-color: #f39800;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .title {
    font-size: 0.32rem;
    font-family: 微软雅黑;
    /*font-weight:bold;*/
    padding: 0.1rem 0px;
    color: #333333;
    .title_item {
      font-size: 0.28rem;
      font-weight: 500;
      padding-left: 0.37rem;
      padding-bottom: 0.08rem;
      padding-top: 0.08rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      span {
        margin-left: 0.1rem;
      }
    }
  }
  .sub_btn {
    font-size: 16px;
    width: 60vw;
    min-height: 38px;
    margin: auto;
    margin-top: 0.2rem;
    border: 1px solid rgba(230, 230, 230, 1);
    background: linear-gradient(#21afff, #007fff);
    border-radius: 5px;
    color: #ffffff;
    outline: none;
  }
}
div {
  background: #ffffff;
}
.box {
  background: #ffffff;
  /*min-height: 5.4rem;*/
  flex-grow: 1;
  width: 100vw;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
}
.container {
  padding: 0.2rem 0.3rem;
  box-sizing: border-box;
  flex-grow: 1;
  width: 100vw;
  height: 100%;
  position: relative;
  z-index: 0;
  overflow-y: scroll;
  /*会导致z-index失效*/

  -webkit-overflow-scrolling: touch;
  img {
    width: 3rem;
    height: 2.6rem;
  }
}
.livetitle {
  width: 7.5rem;
  padding: 0.15rem 0.25rem 0.2rem 0.29rem;
  box-sizing: border-box;
  /*line-height: 0.4rem;*/
  p {
    font-size: 0.28rem;
    color: #666666;
  }
  .title {
    width: 100%;
  }
  .name {
    /*width: 5rem;*/
    color: #333333;
    font-size: 0.34rem;
    font-weight: bold;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; //2行
    -webkit-box-orient: vertical;
    /*white-space: nowrap;*/
    text-overflow: ellipsis;
  }
}
.videotitle {
  width: 7.5rem;
  /*height: 1.34rem;*/
  font-size: 0.28rem;
  line-height: 0.5rem;
  padding: 0.15rem 0.25rem 0.2rem 0.29rem;
  box-sizing: border-box;
  .videodesc {
    // display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    .videoSk {
      background: #7bbfff;
      color: #fff;
      border-radius: 0.2rem;
      font-size: 0.22rem;
      padding: 0.15rem 0.15rem;
    }
    p {
      display: inline;
      color: #666666;
    }
    img {
      width: 0.38rem;
      height: 0.38rem;
      margin-right: 0.09rem;
    }
  }
  .img_text {
    float: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 1.8rem;
    img {
      width: 0.38rem;
      height: 0.38rem;
      margin-right: 0.09rem;
      position: relative;
      top: -0.04rem;
    }
    font-size: 0.28rem;
    color: #666666;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .name {
      /*width: 5rem;*/
      color: #333333;
      font-size: 0.34rem;
      font-weight: bold;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; //2行
      -webkit-box-orient: vertical;
      /*white-space: nowrap;*/
      /*text-overflow: ellipsis;*/
    }
    .img_text {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 1.8rem;

      color: #666666;
    }
  }
}
.menus {
  background: #ffffff;
  z-index: 100;
}
.tabmenus {
  display: flex;
  width: 7.5rem;
  height: 0.8rem;
  background: #ffffff;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  font-size: 0.28rem;
  color: #666666;
  align-items: center;
  z-index: 1;
  li {
    width: 2.46rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  li:nth-of-type(2) > span {
    display: inline-block;
    width: 2.46rem;
    line-height: 0.3rem;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    /*border-right: 1px solid #E6E6E6;*/
  }
  .active {
    color: #ff781b;
    border-bottom: 1px solid #ff781b;
  }
  li:nth-of-type(3) > span {
    display: inline-block;
    width: 2.46rem;
    line-height: 0.3rem;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    /*border-right: 1px solid #E6E6E6;*/
  }
}
.footer_yybm {
  width: 1.4rem;
  height: 0.5rem;
  flex-shrink: 0;
  background: linear-gradient(
    0deg,
    rgba(9, 131, 255, 1) 0%,
    rgba(33, 175, 255, 1) 100%
  );
  border-radius: 25px;
  font-size: 0.26rem;
  color: #ffffff;
  border: none;
  outline: none;
}
video {
  width: 7.5rem;
  height: 4.22rem;
}
#messageinfo {
  z-index: 1002;
}
.messageinfo {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  z-index: 1002;

  button {
    border: none;
    outline: none;
    background: linear-gradient(#e7e8e9, #babbbb);
    width: 2rem;
    height: 0.6rem;
    color: #666666;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }
  .usertext {
    width: 80%;
    background: #ffffff;
    border-radius: 5px;
    font-size: 0.28rem;
    margin: 4rem auto;
    // height: 3rem;
    padding: 0.3rem 0.4rem;
    padding-top: 0.7rem;
    box-sizing: border-box;
    display: flex;
    z-index: 1002 !important;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    position: relative;
    .close {
      position: absolute;
      width: 1rem;
      height: 1rem;
      right: 0.15rem;
      top: 0.15rem;
      background: none;
      span {
        display: inline-block;
        width: 0.44rem;
        height: 0.44rem;
        background: url("../../assets/images/close.png") no-repeat;
        background-size: 100% 100%;
        margin: auto;
      }
    }
    p:nth-of-type(2) {
    }
    .usertext-bnt {
      width: 95%;
      height: 0.8rem;
      font-size: 0.32rem;
      line-height: 0.8rem;
      margin-top: 0.5rem;
      background: linear-gradient(#21afff, #007fff);
      color: #ffffff;
    }
  }
  .reguserinfo {
    width: 6rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    margin: 3rem auto;
    padding: 0.3rem;
    ul {
      font-size: 0.24rem;
      padding: 0.3rem;
      box-sizing: border-box;
      li {
        text-align: left;
        margin-bottom: 0.2rem;
        input {
          width: 4rem;
          height: 0.5rem;
          padding: 0 0.2rem;
          box-sizing: border-box;
          outline: none;
        }
        .important {
          color: #c4171f;
        }
      }
    }
    p {
      display: flex;
      justify-content: space-around;
      padding: 0.2rem;
      box-sizing: border-box;
      button:nth-of-type(2) {
        background: #007eff;
        color: #ffffff;
      }
    }
  }
}
.showimg {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  img {
    width: 100%;
    margin-top: 2rem;
    z-index: 9999;
  }
}

#homeicon {
  position: absolute;
  bottom: 1.3rem;
  right: 0.3rem;
  width: 1rem;
  height: 1rem;
  /*z-index: 2;*/
}
.people {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span:nth-of-type(1) {
    font-size: 0.26rem;
  }
}

.member {
  background: rgba(0, 0, 0, 0.5);
  min-width: 100vw;
  min-height: 100vh;
  position: fixed !important;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 9999 !important;
  > div {
    width: 5rem;
    z-index: 10001 !important;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 0.16rem;
    margin: 4rem auto;
    height: 3.5rem;
    padding: 0.2rem 0.28rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ul {
      width: 100%;
      li:nth-of-type(1) {
        font-weight: bolder;
        font-size: 0.32rem;
      }
      li:nth-of-type(2) {
        text-indent: 0.56rem;
        font-size: 0.28rem;
        margin-top: 0.2rem;
      }
      li {
        width: 100%;
        font-size: 0.28rem;
      }
    }
    > p {
      width: 100%;
      display: flex;
      justify-content: space-between;
      button {
        width: 2rem;
        height: 0.6rem;
        border: none;
        outline: none;
        background: linear-gradient(#e7e8e9, #babbbb);
        color: #333;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
      }
      a > button {
        color: #ffffff;
        background: linear-gradient(#21afff, #007fff);
      }
    }
  }
}

.nothing {
  width: 3rem;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-top: 1.5rem;
  /*height: 100%;*/
}
.limits {
  img {
    width: 2.64rem;
    height: auto;
  }
  margin: 0 auto;
  margin-top: 0.7rem;
  font-size: 0.28rem;
  color: #666666;
  text-align: center;
  line-height: 0.44rem;
  .goMen {
    color: #5bb8f8;
  }
}
.buyCC {
  width: 100%;
  background: #05a2ff;
  position: fixed;
  bottom: 0px;
  font-size: 0.3rem;
  color: #fff;
  text-align: center;
  line-height: 0.9rem;
  height: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/container/vDetails.vue